/**
 * Shared city search module.
 * Used by both the hero search (homepage) and the header search (navigation bar).
 *
 * Usage:
 *   initCitySearch({
 *     inputSelector: '#my-input',
 *     resultsSelector: '#my-results',
 *     containerSelector: '.my-container'
 *   });
 */
(function () {
  'use strict';

  var INDEX_URL = document.currentScript && document.currentScript.dataset.index;
  var COORDS_URL = document.currentScript && document.currentScript.dataset.coords;
  var FRANCE_URL = document.currentScript && document.currentScript.dataset.france;
  var PLACES_API = 'https://admin.clubchauvin.fr/api/lieux?q=';

  function fetchPlaces(query, signal) {
    return fetch(PLACES_API + encodeURIComponent(query), { signal: signal })
      .then(function (r) {
        return r.json();
      })
      .then(function (rows) {
        return rows.map(function (row) {
          return communeItem(row);
        });
      })
      .catch(function () {
        return [];
      });
  }
  var PRODUCT_WORDS = /\b(tasses?|mugs?|affiches?|posters?|magnets?|aimants?|tee shirts?|t shirts?|tshirts?|porte cles?|porte clefs?|torchons?|puzzles?|cartes? postales?|cartes?|serviettes?|gourdes?|carnets?|tote bags?|totes?|sacs?|cadeaux?|souvenirs?)\b/g;
  var indexPromise = null;
  var francePromise = null;
  var france = null;
  var loaded = null;
  var departmentNames = {};
  var photos = {};

  function fetchJson(url) {
    return url
      ? fetch(url)
          .then(function (r) {
            return r.json();
          })
          .catch(function () {
            return null;
          })
      : Promise.resolve(null);
  }

  function rekey(table) {
    var out = {};
    Object.keys(table).forEach(function (key) {
      out[normalise(key)] = (out[normalise(key)] || []).concat(table[key]);
    });
    return out;
  }

  function searchable(rows, aliases, rowOf, sizeAt) {
    var t = { cn: [], ci: [], cc: [], size: [], words: Object.create(null), glued: Object.create(null) };
    var entries = rows.map(function (row, i) {
      return [row[0], i, true];
    });
    Object.keys(aliases).forEach(function (n) {
      aliases[n].forEach(function (target) {
        entries.push([n, rowOf(target), false]);
      });
    });
    function file(b, part, i) {
      var list = (b[part.slice(0, 2)] = b[part.slice(0, 2)] || []);
      if (list[list.length - 1] !== i) list.push(i);
    }
    return new Promise(function (done) {
      var k = 0;
      (function slice() {
        for (var end = Math.min(k + 1500, entries.length); k < end; k++) {
          var e = entries[k];
          var i = t.cn.length;
          var n = e[2] ? normalise(e[0]) : e[0];
          t.cn.push(n);
          t.ci.push(e[1]);
          if (e[2]) {
            t.cc.push(compact(e[0]));
            t.size.push(rows[e[1]][sizeAt] || 0);
            file(t.glued, t.cc[i], i);
          }
          n.split(' ').forEach(function (w) {
            file(t.words, w, i);
          });
        }
        if (k < entries.length) setTimeout(slice, 0);
        else done(t);
      })();
    });
  }

  function loadIndex() {
    if (!indexPromise) {
      indexPromise = fetchJson(INDEX_URL).then(function (idx) {
        if (!idx) return null;
        idx.c = idx.c.map(function (r) {
          return [r[0], r[3] || handleOf(r[0]), r[1], r[2]];
        });
        (idx.dn || idx.d.map(function (d) { return d[0]; })).forEach(function (name) {
          departmentNames[normalise(name)] = true;
        });
        idx.byName = Object.create(null);
        idx.byHandle = Object.create(null);
        idx.c.forEach(function (c, i) {
          var n = nameKey(c[0]);
          idx.byHandle[c[1]] = i;
          (idx.byName[n] = idx.byName[n] || []).push(i);
        });
        idx.z = rekey(idx.z);
        idx.a = rekey(idx.a);
        return searchable(
          idx.c,
          idx.a,
          function (i) {
            return i;
          },
          3
        ).then(function (t) {
          t.item = function (i) {
            return communeItem(idx.c[i]);
          };
          idx.t = t;
          window.citySearchIndexed = true;
          document.dispatchEvent(new Event('citysearch:indexed'));
          return (loaded = idx);
        });
      });
    }
    return indexPromise;
  }

  function loadFrance() {
    if (!francePromise) {
      francePromise = fetchJson(FRANCE_URL).then(function (fr) {
        if (!fr) return null;
        var deltas = fr.c.split(',');
        var number = 0;
        var rows = fr.n.split('|').map(function (nom, i) {
          number += parseInt(deltas[i], 36);
          return [nom, inseeCode(number), fr.s.charCodeAt(i) - 48];
        });
        var order = rows
          .map(function (r, i) {
            return i;
          })
          .sort(function (a, b) {
            return rows[b][2] - rows[a][2] || a - b;
          });
        var rank = [];
        order.forEach(function (i, k) {
          rank[i] = k;
        });
        fr.f = order.map(function (i) {
          return rows[i];
        });
        return searchable(
          fr.f,
          rekey(fr.a),
          function (row) {
            return rank[row];
          },
          2
        ).then(function (t) {
          t.item = function (i) {
            var code = fr.f[i][1];
            var dep = code.slice(0, /^9[78]/.test(code) ? 3 : 2);
            return { nom: fr.f[i][0], code: code, departement: { code: dep, nom: fr.d[dep] } };
          };
          t.d = fr.d;
          return (france = t);
        });
      });
    }
    return francePromise;
  }

  function handleOf(title) {
    var slug = title
      .toLowerCase()
      .normalize('NFD')
      .replace(/[̀-ͯ]/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-|-$/g, '');
    return 'cadeaux-souvenirs-' + (/^[aeiouyh]/.test(slug) ? 'd-' : 'de-') + slug;
  }

  function inseeCode(n) {
    var corsica = n >= 201000 ? '2B' : n >= 200000 ? '2A' : '';
    return corsica ? corsica + String(n % 1000 + 1000).slice(1) : String(n + 100000).slice(1);
  }

  function pathOf(url) {
    return url.split('?')[0];
  }

  function remember(collection) {
    if (collection.featured_image && collection.featured_image.url) {
      photos[pathOf(collection.url)] = collection.featured_image;
    }
  }

  var shopifyRoot =
    window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root
      : '/';

  function searchCollections(query, limit, signal) {
    return fetch(
      shopifyRoot +
        'search/suggest.json?q=' +
        encodeURIComponent(query) +
        '&resources[type]=collection&resources[limit]=' +
        (limit || 8),
      { signal: signal }
    )
      .then(function (r) {
        return r.json();
      })
      .then(function (data) {
        return data.resources.results.collections || [];
      })
      .catch(function () {
        return [];
      });
  }

  function geoCommunes(params, signal) {
    return fetch(
      'https://geo.api.gouv.fr/communes?' + params + '&fields=nom,code,codesPostaux,centre,departement,population&boost=population',
      { signal: signal }
    )
      .then(function (r) {
        return r.json();
      })
      .catch(function () {
        return [];
      });
  }

  function row(href, modifier, image, title, subtitle) {
    return (
      '<a href="' +
      href +
      '" class="city-search-result-item' +
      modifier +
      '">' +
      '<div class="city-search-result-image">' +
      '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#999" stroke-width="1.5"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z"></path><circle cx="12" cy="10" r="3"></circle></svg>' +
      (image && image.url
        ? '<img src="' + image.url + (image.url.indexOf('?') < 0 ? '?' : '&') + 'width=120" alt="">'
        : '') +
      '</div>' +
      '<div class="city-search-result-info">' +
      '<span class="city-search-result-title">' +
      title +
      '</span>' +
      (subtitle ? '<span class="city-search-result-subtitle">' + subtitle + '</span>' : '') +
      '</div>' +
      '</a>'
    );
  }

  function closeness(q, n, max) {
    var prev = [];
    var best = Infinity;
    for (var j = 0; j <= q.length; j++) prev[j] = j;
    for (var i = 1; i <= n.length; i++) {
      var cur = [i];
      var low = i;
      for (var k = 1; k <= q.length; k++) {
        cur[k] = Math.min(prev[k] + 1, cur[k - 1] + 1, prev[k - 1] + (n[i - 1] === q[k - 1] ? 0 : 1));
        if (cur[k] < low) low = cur[k];
      }
      if (low > max) return best;
      if (i < n.length && q.length >= 6 && i >= q.length - 1 && i <= q.length + 1) best = Math.min(best, cur[q.length] + 0.5);
      prev = cur;
    }
    return Math.min(best, prev[q.length]);
  }

  function departmentOf(item) {
    var c = loaded && loaded.c[loaded.byHandle[pathOf(item.url).replace('/collections/', '')]];
    return c && c[2];
  }

  function communeItem(c) {
    return { title: c[0], url: '/collections/' + c[1] };
  }

  function indexMatches(q, idx) {
    var items = [];
    var seen = {};
    function add(item) {
      if (!seen[item.url]) {
        seen[item.url] = true;
        items.push(item);
      }
    }
    function addDepartment(name) {
      idx.d.forEach(function (d) {
        if (d[0] === name) add({ title: d[0], url: '/pages/' + d[1], subtitle: 'Département' });
      });
    }
    (idx.z[q] || []).forEach(addDepartment);
    idx.d.forEach(function (d) {
      var n = normalise(d[0]);
      if (n === q || (q.length >= 5 && n.indexOf(q) === 0)) addDepartment(d[0]);
    });
    return items.slice(0, 8);
  }

  function localMatches(q, t, typed) {
    var starts = [];
    var words = [];
    var glued = [];
    var cq = compact(typed);
    var seen = {};
    (q.length < 2 ? Object.keys(t.cn) : t.words[q.slice(0, 2)] || []).forEach(function (i) {
      var n = t.cn[i];
      if (n.indexOf(q) === 0) starts.push(+i);
      else if (q.length >= 3 && n.indexOf(' ' + q) > 0) words.push(+i);
      else return;
      seen[i] = true;
    });
    if (cq.length >= 3)
      (t.glued[cq.slice(0, 2)] || []).forEach(function (i) {
        if (!seen[i] && t.cc[i].indexOf(cq) === 0) glued.push(i);
      });
    var article = /^(le|la|les|l)\W/i.test(typed);
    function exact(i) {
      return t.cn[i] === q && !(article && i < t.cc.length && t.cc[i].indexOf(cq) !== 0);
    }
    starts.sort(function (a, b) {
      return exact(b) - exact(a) || a - b;
    });
    return rowsAt(starts.concat(words, glued), t);
  }

  function allWords(q, t) {
    var words = q.split(' ').filter(function (w) {
      return w.length >= 2;
    });
    if (words.length < 2) return [];
    var hits = [];
    t.cn.forEach(function (n, i) {
      var spaced = ' ' + n;
      if (
        words.every(function (w) {
          return spaced.indexOf(' ' + w) >= 0;
        })
      )
        hits.push(i);
    });
    return rowsAt(hits, t);
  }

  function rowsAt(positions, t) {
    var seen = {};
    return positions
      .map(function (i) {
        return t.ci[i];
      })
      .filter(function (c) {
        return c !== undefined && !seen[c] && (seen[c] = true);
      });
  }

  function withoutPlaceName(q, idx) {
    var names = idx.d
      .map(function (d) {
        return normalise(d[0]);
      })
      .concat(Object.keys(idx.z));
    var rest = q;
    var places = [];
    for (var i = 0; i < names.length; i++) {
      var name = names[i];
      var before = rest;
      if (rest.length > name.length + 2 && rest.slice(-name.length - 1) === ' ' + name) rest = rest.slice(0, -name.length - 1);
      else if (rest.length > name.length + 2 && rest.indexOf(name + ' ') === 0) rest = rest.slice(name.length + 1);
      if (rest !== before) {
        rest = rest.replace(/( (sur|en|de|du|des|dans|pres|les|lez))+$/, '').trim();
        places = places.concat(idx.z[name] || name).map(normalise);
        i = -1;
      }
    }
    return rest !== q && { rest: rest, places: places };
  }

  function closestCommunes(q, t) {
    if (q.length < 4) return [];
    var max = q.length >= 7 ? 2 : 1;
    var hits = [];
    var longest = q.split(' ').sort(function (a, b) {
      return b.length - a.length;
    })[0];
    var piece = longest.length >= 6 && longest !== q ? longest.slice(0, 3) : null;
    t.cn.forEach(function (n, i) {
      var start =
        n[0] === q[0] ||
        n.slice(1, 3) === q.slice(1, 3) ||
        n.slice(1, 3) === q.slice(0, 2) ||
        n.slice(0, 2) === q.slice(1, 3);
      if (!start && !(piece && n.indexOf(piece) >= 0)) return;
      var d = n.length < q.length - max || (q.length < 6 && n.length > q.length + max) ? Infinity : closeness(q, n, max);
      if (d <= max + 0.5) hits.push([d, i]);
    });
    hits.sort(function (a, b) {
      return a[0] - b[0];
    });
    return rowsAt(
      hits.map(function (h) {
        return h[1];
      }),
      t
    );
  }

  function escapeHtml(str) {
    return str.replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }

  function compact(str) {
    return str
      .toLowerCase()
      .replace(/œ/g, 'oe')
      .replace(/æ/g, 'ae')
      .normalize('NFD')
      .replace(/[̀-ͯ]/g, '')
      .replace(/[^a-z0-9]/g, '');
  }

  /**
   * Normalise a string for comparison (lowercase, no diacritics, articles
   * stripped, hyphens/apostrophes treated as spaces). Lets "Mont Saint-Michel"
   * (Shopify collection) match "Le Mont-Saint-Michel" (INSEE commune name).
   */
  function normalise(str) {
    return str
      .toLowerCase()
      .replace(/œ/g, 'oe')
      .replace(/æ/g, 'ae')
      .normalize('NFD')
      .replace(/[̀-ͯ]/g, '')
      .replace(/^(le |la |les |l')/, '')
      .replace(/[\s\-'’.]+/g, ' ')
      .replace(/\b(st|ste|sainte)\b/g, 'saint')
      .replace(/(^| )[ld] /g, '$1')
      .trim();
  }

  /** « Beaumont (Puy-de-Dôme) » → clé de « Beaumont » ; « Château-Chinon (Ville) » garde sa parenthèse. */
  function nameKey(title) {
    return normalise(bareName(title));
  }

  function bareName(title) {
    var m = /^(.*?)\s*\(([^()]*)\)$/.exec(title);
    return m && departmentNames[normalise(m[2])] ? m[1] : title;
  }

  /**
   * Initialise a city search instance on the given elements.
   * Can be called multiple times for different search inputs on the same page.
   */
  function initCitySearch(config) {
    var input = document.querySelector(config.inputSelector);
    var resultsContainer = document.querySelector(config.resultsSelector);
    var container = document.querySelector(config.containerSelector);

    if (!input || !resultsContainer) return;

    var searchTypingTimer;
    var current = null;
    var lastShown = null;

    function now() {
      return window.performance && performance.now ? performance.now() : Date.now();
    }

    function timed(search, key, promise) {
      var start = now();
      return promise.then(function (value) {
        search.t[key] = Math.round(now() - start);
        return value;
      });
    }

    function network() {
      var c = navigator.connection || {};
      return {
        type: c.effectiveType,
        rtt: c.rtt,
        down: c.downlink,
        save: c.saveData || undefined,
        mem: navigator.deviceMemory,
        cpu: navigator.hardwareConcurrency,
      };
    }

    function report(type, data) {
      if (typeof window.ccJourney === 'function') window.ccJourney(type, { search: data });
    }

    function summary(search, extra) {
      return Object.assign(
        {
          v: 2,
          q: search.q,
          ms: search.first,
          done: Math.round(now() - search.start),
          t: search.t,
          net: network(),
          n: visible(search).items.length,
          soon: visible(search).soon.length,
          cp: search.postal || undefined,
          product: (search.productOnly && !search.items.length) || undefined,
        },
        extra
      );
    }

    function isPostalCode(query) {
      return /^\d{2,5}$/.test(query.trim());
    }

    /* ---- results ---- */

    function add(search, item) {
      var key = pathOf(item.url);
      if (search.seen[key]) return;
      search.seen[key] = true;
      var n = nameKey(item.title);
      (search.names[n] = search.names[n] || []).push(departmentOf(item));
      search.items.push(item);
    }

    function placeCommunes(search, communes, idx) {
      (communes || []).forEach(function (commune) {
        var n = normalise(commune.nom);
        var code = commune.departement && commune.departement.code;
        function same(dep) {
          return !dep || !code || dep === code;
        }
        var i = idx && (idx.byName[n] || []).filter(function (k) {
          return same(idx.c[k][2]);
        })[0];
        if (i !== undefined) add(search, communeItem(idx.c[i]));
        else if (!(search.names[n] || []).some(same)) search.soon.push(commune);
      });
    }

    function fillPhotos(search) {
      return timed(search, 'photos', Promise.all(
        search.items.map(function (item) {
          var key = pathOf(item.url);
          if (item.subtitle || photos[key] || search.asked[key]) return null;
          search.asked[key] = true;
          return searchCollections(item.title, 3, search.signal).then(function (found) {
            found.forEach(remember);
            render(search, false);
          });
        })
      ));
    }

    function visible(search) {
      var shown = { items: search.items, soon: search.soon };
      if (!search.dep || !loaded) return shown;
      var mine = {
        items: search.items.filter(function (item) {
          return item.subtitle || search.dep.indexOf(departmentOf(item)) >= 0;
        }),
        soon: search.soon.filter(function (commune) {
          return commune.departement && search.dep.indexOf(commune.departement.code) >= 0;
        }),
      };
      return mine.items.some(departmentOf) || mine.soon.length ? mine : shown;
    }

    function follow(search) {
      var link = search.go && resultsContainer.querySelector('a');
      if (!link) return;
      search.go = false;
      link.click();
    }

    function render(search, final) {
      if (search !== current) return;
      var shown = visible(search);
      var html = search.postal
        ? '<div class="city-search-postal-badge">📮 Résultats par code postal</div>'
        : '';

      var typed = compact(search.query);
      var said = normalise(search.query);
      var spelled = said.indexOf(' ') > 0 && shown.soon.some(function (commune) {
        return normalise(commune.nom).indexOf(said) === 0;
      });
      function same(title) {
        title = bareName(title);
        return compact(title) === typed && (normalise(title) === said || search.query.indexOf(' ') < 0);
      }
      function rank(entry) {
        return same(entry[0]) && (entry[3] ? 1 : 2);
      }
      shown.items
        .map(function (item) {
          var note = item.subtitle || (item.via && 'Comprend « ' + escapeHtml(item.via) + ' »');
          return [item.title, row(item.url, '', photos[pathOf(item.url)] || item.featured_image, item.title, note), item.loose, !!item.subtitle];
        })
        .concat(
          shown.soon.map(function (commune) {
            return [
              commune.nom,
              row(
                '/pages/ville-bientot-disponible?ville=' + encodeURIComponent(commune.nom) + '&code=' + commune.code,
                ' city-search-result-item--coming-soon',
                null,
                commune.nom,
                commune.departement && commune.departement.nom
              ),
            ];
          })
        )
        .sort(function (a, b) {
          return rank(b) - rank(a) || spelled * (!!a[2] - !!b[2]);
        })
        .forEach(function (entry) {
          html += entry[1];
        });

      if (!shown.items.length && !shown.soon.length) {
        if (!final) return;
        html =
          '<div class="city-search-message">' +
          (search.productOnly
            ? 'Choisissez d’abord votre commune : tapez son nom ou son code postal.'
            : search.postal
            ? 'Aucune commune trouvée pour ce code postal.'
            : 'Aucune commune trouvée.') +
          '</div>';
      }

      resultsContainer.innerHTML = html;
      if (document.activeElement === input) resultsContainer.style.display = 'block';
      if (search.first === undefined) {
        search.first = Math.round(now() - search.start);
        lastShown = { q: search.q, at: now() };
      }
      if (final && !search.reported) {
        search.reported = true;
        report('search', summary(search));
      }
      follow(search);
    }

    /* ---- searching ---- */

    function showLocal(search) {
      var q = normalise(search.query);
      var bare = q
        .replace(PRODUCT_WORDS, ' ')
        .replace(/\b\d+(er|e|eme)?\b/g, ' ')
        .replace(/\s+/g, ' ')
        .trim();
      search.productOnly = bare.length < 2;
      if (bare !== q && !search.productOnly) search.query = q = normalise(bare);

      search.local = loadIndex().then(function (idx) {
        if (!idx) return;
        if (france) return run(france);
        run(null);
        return loadFrance().then(function (fr) {
          if (fr && search === current) run(fr);
        });

        function run(fr) {
          search.rescue = null;
          function both(match, limit) {
            return { items: match(idx.t).slice(0, limit), soon: fr ? match(fr).slice(0, limit) : [] };
          }
          function find(key, typed, limit) {
            var r = both(function (t) {
              return localMatches(key, t, typed);
            }, 1e9);
            var sizes = r.items
              .map(function (i) {
                return idx.t.size[i];
              })
              .concat(
                r.soon.map(function (i) {
                  return fr.size[i];
                })
              )
              .sort(function (a, b) {
                return b - a;
              });
            var cutoff = sizes.length > 10 ? sizes[9] : -1;
            return {
              items: r.items.slice(0, limit),
              soon: r.soon
                .filter(function (i) {
                  return fr.size[i] >= cutoff || (cq.length >= 5 && fr.cc[i] === cq);
                })
                .slice(0, limit),
            };
          }
          function join(a, b) {
            return { items: a.items.concat(b.items), soon: a.soon.concat(b.soon) };
          }
          function found(r) {
            return r.items.length || r.soon.length;
          }
          indexMatches(q, idx).forEach(function (item) {
            add(search, item);
          });
          var cq = compact(search.query);
          var key = q;
          var r = find(key, search.query, 8);
          if (!found(r) && /^([azeqdxw]t|s[rygf]) /.test(q)) r = find((key = 'saint' + q.slice(2)), key, 8);
          var shorter = !found(r) && withoutPlaceName(key, idx);
          if (shorter) {
            r = find((key = shorter.rest), key, 8);
            if (fr && !search.dep)
              search.dep = Object.keys(fr.d).filter(function (code) {
                return shorter.places.indexOf(normalise(fr.d[code])) >= 0;
              });
          }
          function show(r, named) {
            r.items.map(idx.t.item).forEach(function (item) {
              if (named && normalise(item.title).indexOf(key) < 0 && compact(item.title).indexOf(compact(key)) < 0) item.via = search.q;
              add(search, item);
            });
            placeCommunes(search, fr ? r.soon.map(fr.item) : [], idx);
            render(search, false);
          }
          show(r, true);
          if (!found(r) && !search.productOnly)
            search.rescue = function () {
              r = both(function (t) {
                return allWords(q, t);
              }, 3);
              var scattered = found(r);
              if (!scattered)
                r = both(function (t) {
                  return closestCommunes(q, t);
                }, 3);
              for (var words = q.split(' '), parts = [], n = 1; n < words.length; n++)
                parts.splice(n - 1, 0, words.slice(0, -n).join(' ')), parts.push(words.slice(n).join(' '));
              parts.some(function (part, k) {
                var cut = !scattered && part.length >= 5 && find(part, part, 3);
                if (cut && k >= words.length - 1)
                  cut = {
                    items: cut.items.filter(function (i) {
                      return normalise(idx.t.item(i).title) === part;
                    }),
                    soon: cut.soon.filter(function (i) {
                      return normalise(fr.item(i).nom) === part;
                    }),
                  };
                return cut && found(cut) && (r = join(r, cut));
              });
              show(r);
              return fetchPlaces(search.query, search.signal).then(function (items) {
                items.forEach(function (item) {
                  item.via = search.q;
                  add(search, item);
                });
                render(search, false);
              });
            };
        }
      });
    }

    function fetchByName(search) {
      var shopify = timed(search, 'shopify', searchCollections(search.query, 8, search.signal)).then(function (found) {
        var said = ' ' + normalise(search.query);
        found.forEach(function (c) {
          remember(c);
          c.loose = (' ' + normalise(c.title)).indexOf(said) < 0;
          add(search, c);
        });
        render(search, false);
      });
      var rescue = search.local.then(function () {
        return search.rescue && search.rescue();
      });
      return Promise.all([shopify, rescue]).then(function () {
        return fillPhotos(search);
      });
    }

    function fetchByPostalCode(search) {
      resultsContainer.style.display = 'block';
      resultsContainer.innerHTML =
        '<div class="city-search-message">🔍 Recherche par code postal...</div>';
      return Promise.all([
        timed(search, 'geo', geoCommunes('codePostal=' + search.q, search.signal)),
        loadIndex(),
        search.q.length < 4 ? loadFrance() : null,
      ]).then(function (results) {
        var dep = results[2] && results[1] && results[2].d[search.q];
        if (dep)
          indexMatches(normalise(dep), results[1]).forEach(function (item) {
            add(search, item);
          });
        placeCommunes(search, (results[0] || []).sort(function (a, b) {
          return (b.population || 0) - (a.population || 0);
        }), results[1]);
        render(search, false);
        return fillPhotos(search);
      });
    }

    /* ---- event listeners ---- */

    input.addEventListener('input', function () {
      var query = this.value.trim();
      clearTimeout(searchTypingTimer);
      if (current && current.ctrl) current.ctrl.abort();
      current = null;

      if (query.length < 2) {
        resultsContainer.style.display = 'none';
        resultsContainer.innerHTML = '';
        return;
      }

      var tidy = query
        .replace(/’/g, "'")
        .replace(/([a-zà-ÿ])(\d{2,5})$/i, '$1 $2')
        .replace(/\b(La|Le|Les)(?=[A-Z])/g, '$1 ')
        .replace(/\bstes\b\.?/gi, 'Saintes')
        .replace(/\bst\b\.?/gi, 'Saint')
        .replace(/\bste\b\.?/gi, 'Sainte')
        .replace(/\b([dl]) (?=[a-zà-ÿ])/gi, "$1'");
      var department = tidy.match(/^(.*\D)\s*(0[1-9]|[1-8]\d|9[0-5]|97[1-6]|2[ab])$/i);
      if (department && !/[a-zà-ÿ]/i.test(department[1])) department = null;

      var search = (current = {
        q: query,
        query: department ? department[1].trim() : tidy,
        dep: department ? [department[2].toUpperCase()] : null,
        start: now(),
        t: {},
        items: [],
        soon: [],
        seen: {},
        names: {},
        asked: {},
        postal: isPostalCode(query),
        ctrl: window.AbortController ? new AbortController() : null,
      });
      search.signal = search.ctrl ? search.ctrl.signal : undefined;
      if (!search.postal) showLocal(search);

      searchTypingTimer = setTimeout(function () {
        (search.postal ? fetchByPostalCode : fetchByName)(search).then(function () {
          render(search, true);
        });
      }, search.postal ? 500 : 300);
    });

    input.addEventListener('focus', function () {
      if (input.value.trim() && resultsContainer.innerHTML) resultsContainer.style.display = 'block';
    });

    input.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' || !current) return;
      e.preventDefault();
      current.go = true;
      if (current.first !== undefined) follow(current);
    });

    resultsContainer.addEventListener('click', function (e) {
      var link = e.target.closest && e.target.closest('a');
      if (!link || !lastShown) return;
      var links = Array.prototype.slice.call(resultsContainer.querySelectorAll('a'));
      report('search_click', {
        v: 2,
        q: lastShown.q,
        ms: Math.round(now() - lastShown.at),
        pos: links.indexOf(link) + 1,
        href: link.getAttribute('href'),
      });
    });

    window.addEventListener('pageshow', function (e) {
      if (!e.persisted) return;
      input.value = '';
      resultsContainer.style.display = 'none';
      current = null;
    });

    window.addEventListener('pagehide', function () {
      if (!current || current.reported) return;
      current.reported = true;
      report('search', summary(current, { partial: true, abandoned: current.first === undefined || undefined }));
    });

    if (input.value.trim()) input.dispatchEvent(new Event('input'));

    // Close results on click outside
    document.addEventListener('click', function (e) {
      if (container && !container.contains(e.target)) {
        resultsContainer.style.display = 'none';
      }
    });
  }

  function initNearbyCommunes(container, code, name) {
    if (!container || !COORDS_URL || !(code || name)) return;
    Promise.all([
      geoCommunes(code ? 'code=' + encodeURIComponent(code) : 'nom=' + encodeURIComponent(name) + '&limit=1'),
      loadIndex(),
      fetch(COORDS_URL).then(function (r) {
        return r.json();
      }),
    ]).then(function (res) {
      var place = res[0][0];
      var idx = res[1];
      if (!place || !place.centre || !idx) return;
      var lat = place.centre.coordinates[1] * 100;
      var lon = place.centre.coordinates[0] * 100;
      var squeeze = Math.cos((lat / 100) * (Math.PI / 180));
      var near = res[2]
        .map(function (c, i) {
          return [c ? Math.sqrt(Math.pow(c[0] - lat, 2) + Math.pow((c[1] - lon) * squeeze, 2)) * 1.112 : Infinity, i];
        })
        .sort(function (a, b) {
          return a[0] - b[0];
        })
        .filter(function (d) {
          return d[0] <= 40;
        })
        .slice(0, 4)
        .map(function (d) {
          return { item: communeItem(idx.c[d[1]]), km: Math.max(1, Math.round(d[0])) };
        });
      if (!near.length) return;
      function draw() {
        container.innerHTML =
          '<h2 class="city-coming-soon__nearby-title">Les communes les plus proches</h2><div class="city-nearby__grid">' +
          near
            .map(function (n) {
              var image = photos[pathOf(n.item.url)];
              return (
                '<a class="city-nearby__tile" href="' +
                n.item.url +
                '"><div class="city-nearby__img">' +
                (image ? '<img src="' + image.url + (image.url.indexOf('?') < 0 ? '?' : '&') + 'width=400" alt="">' : '') +
                '</div><span class="city-nearby__name">' +
                n.item.title +
                '</span><span class="city-nearby__km">à ' +
                n.km +
                ' km</span></a>'
              );
            })
            .join('') +
          '</div>';
      }
      draw();
      near.forEach(function (n) {
        searchCollections(n.item.title, 3).then(function (found) {
          found.forEach(remember);
          draw();
        });
      });
    });
  }

  loadIndex();
  window.addEventListener('load', loadFrance);

  window.initCitySearch = initCitySearch;
  window.initNearbyCommunes = initNearbyCommunes;
  var waiting = window.citySearchReady || [];
  window.citySearchReady = {
    push: function (start) {
      start();
    },
  };
  waiting.forEach(function (start) {
    start();
  });
})();
